import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { VERTICALS_DESCRIPTION_LIST } from "../../utils/constants";
import { Link } from "@material-ui/core";
import {
  BusinessCenter,
  SquareFoot,
  MenuBook,
  PhoneIphone,
} from "@material-ui/icons";
import Button from "../../ui-components/Button";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  largeIcon: {
    fontSize: "6em",
    paddingTop: 10,
    color: "#87ad84",
    marginBottom: "12px",
  },
  allQuestionLink: {
    textDecoration: "underline",
  },
  link: {
    cursor: "pointer",
  },
});

function FaqHomeCard({
  vertical,
  triplets,
  vmtSelection,
  setNavigationStatus,
  setScrollToObject,
}) {
  const classes = useStyles();

  triplets = triplets
    .filter(
      (obj) => obj.vertical.replaceAll(" ", "") === vertical.replaceAll(" ", "")
    )
    .filter((obj) => obj.questions.length > 0);
  // .sort((a, b) => b.total_views - a.total_views).slice(0, 5)
  // console.log('FaqHomeCard triplets', triplets)

  const unique_macro = [...new Set(triplets.map((item) => item.macrotema))];
  let sorted_macro = [];
  unique_macro.forEach((x) => {
    let temp_values = triplets.filter(
      (obj) => obj.macrotema.replaceAll(" ", "") === x.replaceAll(" ", "")
    );
    sorted_macro.push({
      macrotema: x,
      sum_views: temp_values.reduce((n, { total_views }) => n + total_views, 0),
    });
  });
  let sorted_macro_5 = sorted_macro
    .sort((a, b) => b.sum_views - a.sum_views)
    .slice(0, 5);

  const VerticalIcon = (vertical) => {
    if (typeof vertical.vertical === "string") {
      switch (vertical.vertical) {
        case "Professionale":
          return <MenuBook color="primary" className={classes.largeIcon} />;
        case "Gestionale / Finanziario":
          return (
            <BusinessCenter color="primary" className={classes.largeIcon} />
          );
        case "Tecnico":
          return <SquareFoot color="primary" className={classes.largeIcon} />;
        case "Genius Lab":
          return <PhoneIphone color="primary" className={classes.largeIcon} />;
        default:
          return null;
      }
    }
  };

  const VerticalTitleCounterDescription = (vertical) => {
    // console.log('VerticalTitleCounterDescription vertical', vertical['vertical']);
    let questions_count = triplets
      .filter(function (item) {
        return item.vertical === vertical.vertical;
      })
      .reduce((a, b) => a + (b["questions"].length || 0), 0);
    return (
      <>
        <div>
          <p className="text-center text-xl font-bold text-black-500">
            {vertical.vertical} ({questions_count})
          </p>
        </div>
        <div>
          <p className="text-base text-center">
            {VERTICALS_DESCRIPTION_LIST[vertical["vertical"]]}
          </p>
        </div>
      </>
    );
  };

  const showTop3Macrothemes = (triplet) => {
    return (
      <div key={triplet.macrotema + "homeLink"} style={{ margin: 5 }}>
        <Link
          onClick={() => {
            vmtSelection(vertical);
            setNavigationStatus("vertical_detail");
            setScrollToObject(
              (triplet.macrotema + vertical).concat("treeItem")
            );
          }}
        >
          <p className="text-black-500  hover:text-kkgreen-400 cursor-pointer text-base underline text-center">
            {triplet.macrotema}
          </p>
        </Link>
      </div>
    );
  };

  return (
    <div
      style={{ margin: "1%" }}
      className="p-4 w-98 md:w-48 border-4 border-kkgreen-400"
    >
      <div className="flex flex-col justify-center items-center h-full">
        <div style={{ textAlign: "center" }}>
          <VerticalIcon vertical={vertical} />
        </div>

        <VerticalTitleCounterDescription vertical={vertical} />
        <div className="mt-3 h-full flex flex-col justify-between">
          <div className="mt-4">
            {Object.values(sorted_macro_5).map((i) => showTop3Macrothemes(i))}
          </div>
          <div className="mt-8">
            <Link
              className={classes.link}
              onClick={() => {
                vmtSelection(vertical);
                setNavigationStatus("vertical_detail");
              }}
            >
              <Button styleType="green">Vedi tutte</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqHomeCard;
